<div class="outer-container">
   <div class="button-grid">
      <div class="button-container">
         <button
            pButton
            label="Users"
            (click)="setSelectedButton('users')"
            [ngClass]="{ selected: selectedButton === 'users' }"
            class="custom-btn blue-btn"></button>
      </div>

      <div class="button-container">
         <button
            pButton
            label="Roles"
            (click)="setSelectedButton('roles')"
            [ngClass]="{ selected: selectedButton === 'roles' }"
            class="custom-btn orange-btn"></button>
      </div>
   </div>

   <div class="panel-frame">
      <div
         *ngIf="selectedButton === 'users'"
         class="title-heading">
         <span class="users-heading">Manage User Roles</span>
      </div>

      <div
         *ngIf="selectedButton === 'roles'"
         class="title-heading">
         <span class="roles-heading">Manage Roles</span>
      </div>

      <div
         *ngIf="selectedButton === 'users'"
         class="subtitle-heading">
         <div>search for user</div>

         <div>
            <p-table
               #crttbl
               [value]="filteredUsers"
               [paginator]="true"
               [rows]="40"
               responsiveLayout="scroll"
               [sortField]="'syncDate'"
               [sortOrder]="-1">
               <ng-template pTemplate="caption">
                  <div class="search-header">
                     <p-iconfield>
                        <p-inputicon class="pi pi-search"></p-inputicon>
                        <input
                           pInputText
                           type="text"
                           [(ngModel)]="searchQuery"
                           (input)="onSearchInput()"
                           placeholder="Search..." />
                     </p-iconfield>
                  </div>
               </ng-template>

               <ng-template pTemplate="header">
                  <tr>
                     <th>Dayforce Employee #</th>
                     <th>App.User Id</th>
                     <th>Display Name</th>
                     <th></th>
                  </tr>
               </ng-template>

               <ng-template
                  pTemplate="body"
                  let-user>
                  <tr>
                     <td
                        colspan="3"
                        style="padding: 0; border: none">
                        <div
                           class="user-row-card"
                           [class.expanded]="selectedUserId === user.id">
                           <div
                              class="user-row-content"
                              (click)="onRowClick(user)"
                              style="cursor: pointer">
                              <div class="user-cell">{{ user.loginName }}</div>
                              <div class="user-cell">{{ user.id }}</div>
                              <div class="user-cell">{{ user.displayName }}</div>
                           </div>

                           <div
                              *ngIf="selectedUserId === user.id"
                              class="expanded-row-content"
                              (click)="$event.stopPropagation()">
                              <div style="display: flex; justify-content: left; align-items: center; gap: 12px; width: 100%; margin: 12px">
                                 <vc-single-select-dropdown
                                    class="mr-1"
                                    [items]="rolesForSelection"
                                    optionLabel="label"
                                    optionValue="appRole"
                                    variantClass="v-sitefilter"
                                    sizeClass="v-dropdown-md"
                                    [placeholder]="'Role To Add'"
                                    [filter]="true"
                                    setValue="selectedRoleToAdd"
                                    (selectionChange)="onRoleToAddChange($event)"></vc-single-select-dropdown>

                                 <button
                                    pButton
                                    label="Add Role"
                                    (click)="addSelectedRoleToUser(user)"
                                    [ngClass]=""
                                    class="custom-btn green-btn"></button>
                              </div>

                              <table
                                 class="nested-roles-table"
                                 style="width: 100%; border-collapse: collapse">
                                 <thead>
                                    <tr>
                                       <th style="text-align: left; border-bottom: 1px solid #ccc">Application</th>
                                       <th style="text-align: left; border-bottom: 1px solid #ccc">Role Name</th>
                                       <th></th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                    <tr *ngFor="let role of rolesForUser[user.id.toString()]">
                                       <td style="padding: 4px 8px; border-bottom: 1px solid #eee">{{ role.application }}</td>
                                       <td style="padding: 4px 8px; border-bottom: 1px solid #eee">{{ role.roleName }}</td>
                                       <td>
                                          <button
                                             pButton
                                             label="X"
                                             (click)="removeRoleFromUser(user, role)"
                                             [ngClass]=""
                                             class="custom-btn red-btn remove-role-btn"></button>
                                       </td>
                                    </tr>
                                 </tbody>
                              </table>
                           </div>
                        </div>
                     </td>
                  </tr>
               </ng-template>
            </p-table>
         </div>
      </div>

      <div
         *ngIf="selectedButton === 'roles'"
         class="subtitle-heading">
         select role
      </div>
   </div>
</div>
